import { render, staticRenderFns } from "./StoreManage.vue?vue&type=template&id=97b7b5f6&scoped=true"
import script from "./StoreManage.vue?vue&type=script&lang=js"
export * from "./StoreManage.vue?vue&type=script&lang=js"
import style0 from "./StoreManage.vue?vue&type=style&index=0&id=97b7b5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b7b5f6",
  null
  
)

export default component.exports